module.exports = __webpack_public_path__ + "static/media/ProximaNova-RegularIt.3c67e998.ttf";